import angular from "angular";

angular
    .module('app')
    .component('usersControl', {
        template: require('./users-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            getListLink: '@'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.search = null;
    $ctrl.perPage = '15';
    $ctrl.orderBy = 'id';
    $ctrl.orderDir = 'desc';
    $ctrl.users = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/users/get-list', {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                    type: $ctrl.type,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    per_page: $ctrl.perPage,
                }
            })
            .then(
                function (response) {
                    $ctrl.users = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {

                }
            );
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.type = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openUserCreateForm = function () {
        $uibModal
            .open({
                component: 'userCreateForm',
                size: 'md',
                keyboard: false,
                backdrop: 'static',
            })
            .result
            .then(
                function (result) {
                    $ctrl.users.unshift(result);
                },
                function (error) {

                }
            );
    };

    $ctrl.openUserUpdateForm = function (user) {
        $uibModal
            .open({
                component: 'userUpdateForm',
                resolve: {
                    user: function () {
                        return user;
                    }
                },
                size: 'md',
                keyboard: false,
                backdrop: 'static',
            })
            .result
            .then(
                function (result) {
                    user.id = result.id;
                    user.name = result.name;
                    user.last_name = result.last_name;
                    user.patronymic = result.patronymic;
                    user.phone = result.phone;
                    user.email = result.email;
                },
                function (error) {

                }
            );
    };

    $ctrl.toBan = function (user) {

        if (!confirm('Заблокировать пользователя?')) {
            return;
        }

        if (user.loading) {
            return;
        }

        user.loading = true;

        $http
            .post(`/admin/users/${user.id}/ban`)
            .then(
                function () {
                    user.is_active = false;
                    user.loading = false;
                },
                function (error) {
                    user.loading = false;

                }
            );
    };

    $ctrl.activate = function (user) {

        if (!confirm('Вы уверены?')) {
            return;
        }

        if (user.loading) {
            return;
        }

        user.loading = true;

        $http
            .post(`/admin/users/${user.id}/activate`)
            .then(
                function () {
                    user.is_active = true;
                    user.loading = false;
                },
                function (error) {
                    user.loading = false;

                }
            );
    };

    $ctrl.openCoursesList = function (user) {
        $uibModal
            .open({
                component: 'userCoursesList',
                resolve: {
                    user: function () {
                        return user;
                    }
                }
            })
            .result
            .then(
                function () {

                },
                function () {

                }
            )
    };

    $ctrl.openDevicesList = function (user) {
        $uibModal
            .open({
                component: 'userDevicesList',
                resolve: {
                    user: function () {
                        return user;
                    }
                },
                size: 'lg',
            })
            .result
            .then(
                function () {

                },
                function () {

                }
            )
    }

    $ctrl.deleteUser = (user) => {
        $uibModal
            .open({
                component: 'userDeleteForm',
                resolve: {
                    user() {
                        return user;
                    }
                }
            })
            .result
            .then(() => {
                $ctrl.getList();
            })
    }
}
